import script from "./singleVipRule.vue?vue&type=script&setup=true&lang=js"
export * from "./singleVipRule.vue?vue&type=script&setup=true&lang=js"

import "./singleVipRule.vue?vue&type=style&index=0&id=dd93e930&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd93e930"]])

export default __exports__